import { IAsset } from '../menus/menus.types';

export const getAssetUrl = (assets: IAsset[]) => {
  const asset = assets?.find((asset) => asset.asset_variants && asset.asset_variants.length > 0);
  return asset ? asset.asset_variants[0].url : null;
};
